<script setup>
import { Link } from '@inertiajs/vue3';
import ApplicationLogo from '@/Components/Logo/ApplicationLogo.vue';
import IconMenu from '@/Components/Icons/IconMenu.vue';
import { reactive } from 'vue';
import IconClose from '@/Components/Icons/IconClose.vue';
import PartnerLogo from '@/Components/Logo/PartnerLogo.vue';
import { usePage } from '@inertiajs/vue3';

const page = usePage();
const branding = page.props.branding;

const state = reactive({
  isMobileMenuOpen: false
});

const emit = defineEmits(['toggleMobileMenu']);

const toggleMobileMenu = () => {
  state.isMobileMenuOpen = !state.isMobileMenuOpen;
  emit('toggleMobileMenu', state.isMobileMenuOpen);
};
</script>

<template>
  <div class="relative">
    <div class="flex items-center justify-between">
      <div class="dark flex items-center gap-4 md:gap-10">
        <Link tabindex="-1" :href="route('score.index')">
          <ApplicationLogo />
        </Link>
      </div>
      <partner-logo
        v-if="branding?.co_branded_logo"
        :partner-logo="branding?.co_branded_logo"
      />
    </div>
    <div
      class="bg-foreground mt-3 rounded"
      :class="{ 'rounded-b-none': state.isMobileMenuOpen }"
    >
      <button
        class="text-grey-400 hover:bg-white-600 flex cursor-pointer rounded-sm p-2 focus:ring-3 md:hidden"
        @click="toggleMobileMenu"
      >
        <IconMenu v-if="!state.isMobileMenuOpen" />
        <IconClose v-else />
        <span class="ml-2">Menu</span>
      </button>
    </div>
  </div>
</template>
